/**
 * Day-strip geometry: everything as % of a 24h rail. Ranges that wrap past
 * midnight split into two segments (mock behavior). Pure — the DayStrip
 * component just paints these.
 * For Media Devoted | Created By Ciro Autiero
 */
const DAY = 1440;

export interface StripSegment {
  leftPct: number;
  widthPct: number;
}

const pct = (min: number) => (((min % DAY) + DAY) % DAY) / DAY * 100;

/** A [start, end) range on the rail; wraps split into two segments. */
export function rangeSegments(startMin: number, endMin: number): StripSegment[] {
  const start = ((startMin % DAY) + DAY) % DAY;
  const end = ((endMin % DAY) + DAY) % DAY;
  if (startMin === endMin) return [];
  if (start < end) {
    return [{ leftPct: pct(start), widthPct: ((end - start) / DAY) * 100 }];
  }
  return [
    { leftPct: pct(start), widthPct: ((DAY - start) / DAY) * 100 },
    { leftPct: 0, widthPct: (end / DAY) * 100 },
  ];
}

/** Tick positions for slot minutes (wrapped onto the rail). */
export function tickPositions(minutes: number[]): number[] {
  return minutes.map(pct);
}

export const STRIP_AXIS_LABELS = ['00', '06', '12', '18', '24'] as const;
